import { render, staticRenderFns } from "./GatewayTab.vue?vue&type=template&id=e1a810d6&"
import script from "./GatewayTab.vue?vue&type=script&lang=js&"
export * from "./GatewayTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports